import DoAmount from './DoAmount';

/* istanbul ignore next */
DoAmount.install = function (Vue) {
    Vue.component(DoAmount.name, DoAmount);
};

export default DoAmount;